<bcb-generic-label [question]="question"></bcb-generic-label>

<div class="url-list">
	<div
		class="url-list__row"
		*ngFor="let row of rows.controls; let i = index"
	>
		<mat-form-field appearance="outline" class="url-list__field">
			<input
				matInput
				[formControl]="$any(row)"
				(blur)="onRowBlur(i)"
				placeholder="https://example.com"
			/>
			<mat-error *ngIf="rowError(i)">{{ rowError(i) }}</mat-error>
		</mat-form-field>

		<button
			mat-icon-button
			type="button"
			class="url-list__remove"
			(click)="removeRow(i)"
			[disabled]="rows.disabled"
			aria-label="Remove website URL"
		>
			<mat-icon>remove_circle_outline</mat-icon>
		</button>
	</div>

	<button
		mat-stroked-button
		type="button"
		class="url-list__add"
		(click)="addRow()"
		[disabled]="rows.disabled"
	>
		<mat-icon>add</mat-icon>
		Add website URL
	</button>
</div>
